<template>
  <div class="searchList" :class="isLeftDrawVisible?'fade-left-visible':'fade-left-invisible'" v-show="isVisible">
    <ul class="search-result">
      <li v-for="(item, index) in searchList" :key="index" @click="onSelectMarker(item)">
        <img class="poi-image markerImg" v-if="searchParams.searchType==='1'" :src="item.icon">
        <div class="point-icon" v-else>
          <img :src="getLayerIcon(item).url" v-if="getLayerIcon(item).module!=='FLAT'">
          <svg :fill="getLayerIcon(item).color" aria-hidden="true" v-else>
            <use :xlink:href="'#icon-'+getLayerIcon(item).name"></use>
          </svg>
        </div>
        <el-tooltip :content="item.name" placement="top" effect="light" :open-delay="1000" :enterable="false">
          <span>{{item.name}}</span>
        </el-tooltip>
        <div class="line"></div>
      </li>
      <div v-show="searchList.length<=0">
        <Empty></Empty>
      </div>
    </ul>
    <el-pagination ref="pager" class="search-page" :class="searchParams.searchType==='1'&&totalCount>50?'disable-last':''" layout="prev, slot, next" :disabled="isDrawState" :total="totalCount" :pager-count="5" :current-page="curPage" @current-change="onPageChanged">
      <div slot class="page-slot">{{curPage}}</div>
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import coordtransform from 'coordtransform'
import * as markerStyles from '@/utils/markerStyles'
export default {
  name: 'SearchList',
  computed: {
    ...mapGetters(['isLeftDrawVisible', 'searchResult', 'searchParams', 'layerList', 'isDrawState'])
  },
  inject: ['shared', 'cesiumViewer'],
  watch: {
    searchParams: {
      deep: true,
      handler (val) {
        if (!val.searchInputText) {
          this.$cesiumPlus.markerManager.removeMarkerByLayer('poisearch')
          this.$cesiumPlus.markerManager.removeMarkerByLayer('markerSearch')
          this.$emit('selectedPoi', undefined)
          this.close()
          return
        }
        if (val.searchType === '1') {
          this.requestSearchPoi(val)
        } else if (val.searchType === '2') {
          // this.requestSearchMarker(val)
          this.searchLocalMarker(val)
        }
        this.isVisible = true
      }
    }
  },
  data () {
    return {
      isVisible: false,
      totalCount: 50,
      curPage: 1,
      searchList: []
    }
  },
  mounted () {
    this.clientIp = returnCitySN.cip
    this.clientCityId = returnCitySN.cid
  },
  methods: {
    ...mapActions(['poiSearch', 'markerSearch', 'clearSearch', 'searchMarker', 'searchSppucMarker']),

    getLayerIcon (data) {
      // return markerStyles.getIconData(data.pointStyle.icon)
      const layer = this.layerList.find((key) => { return key.id === data.layerId })
      if (layer.type === 'POINT') {
        const iconData = markerStyles.getIconData(layer.pointStyle.icon)
        if (layer.pointStyle.type === 'HEAT_MAP') {
          iconData.url = require('@/assets/images/dian.png')
          iconData.module = 'PERSONAL'
        }
        return {
          ...iconData,
          color: layer.pointStyle.color
        }
      } else if (layer.type === 'LINE') {
        return {
          url: require('@/assets/images/line-a.png'),
          name: 'Line-a2',
          module: 'FLAT',
          color: '#00A4F0'
        }
      } else if (layer.type === 'PLANE') {
        return {
          url: require('@/assets/images/noodles-a.png'),
          name: 'noodles-a',
          module: 'FLAT',
          color: '#00A4F0'
        }
      }
    },
    // 点击标注
    onSelectMarker (item) {
      if (this.isDrawState) {
        return
      }
      if (this.searchParams.searchType === '1') {
        this.selectPoiMarker(item)
      } else if (this.searchParams.searchType === '2') {
        this.selectSearchMarker(item)
      }
    },
    // 选择poi标注
    selectPoiMarker (item) {
      const id = 'poisearch-' + item.id
      const marker = this.$cesiumPlus.markerManager.getMarkerById(id)
      if (!marker) {
        this.$cesiumPlus.markerManager.createMarker({
          layerId: 'poisearch',
          name: item.name,
          position: item.poistion,
          id: 'poisearch-' + item.id,
          // allowPick: false,
          properties: {
            index: item.index
          },
          billboard: {
            show: true
          },
          drawMode: CesiumPlus.DrawMode.Marker,
          style: [
            new CesiumPlus.BillboardStyle({
              image: require(`@/assets/images/blue${item.index + 1}.png`),
              color: Cesium.Color.fromCssColorString('#FFFFFF'),
              show: true
            })
          ]
        })
        this.$emit('selectedPoi', item)
        return
      }
      const position = marker.getPosition()
      this.$cesiumPlus.cameraManager.zoomToPosition(position)
      const sources = this.$cesiumPlus.markerManager.getDataSourceByLayer('poisearch')
      if (sources && sources.entities.values.length > 0) {
        for (let i = 0; i < sources.entities.values.length; i++) {
          const entity = sources.entities.values[i]
          const marker = this.$cesiumPlus.markerManager.getMarkerById(entity.id)
          const index = marker.properties.index
          if (entity.id === id) {
            marker.setStyle([
              new CesiumPlus.BillboardStyle({
                image: require(`@/assets/images/blue${index + 1}.png`),
                color: Cesium.Color.fromCssColorString('#FFFFFF'),
                show: true
              })
            ])
          } else {
            marker.setStyle([
              new CesiumPlus.BillboardStyle({
                image: require(`@/assets/images/red${index + 1}.png`),
                color: Cesium.Color.fromCssColorString('#FFFFFF'),
                show: true
              })
            ])
          }
        }
      }
      this.$emit('selectedPoi', item)
    },
    // 通过标注id选择poi
    selectPoiById (markerId) {
      for (let i = 0; i < this.searchList.length; i++) {
        if (`poisearch-${this.searchList[i].id}` === markerId) {
          this.selectPoiMarker(this.searchList[i])
        }
      }
    },
    // 选中搜索标注
    selectSearchMarker (item) {
      // const marker = this.$cesiumPlus.markerManager.getMarkerById(item.id)
      // if (marker && marker.isVisibleInScene()) {
      //   this.$store.dispatch('selectMarker', item.id)
      // } else {
      //   const selectedId = item.id
      //   this.$store.dispatch('selectMarker', selectedId)
      // }
      const layer = this.layerList.find((key) => { return key.id === item.layerId })
      if (layer.module === 'sppuc') {
        let sppucMarkerId
        const marker = this.$cesiumPlus.markerManager.getMarkerById(item.id)
        if (!marker || !marker.isVisibleInScene()) {
          sppucMarkerId = `markerSearch-${item.id}`
        } else {
          sppucMarkerId = item.id
        }
        const deviceId = item.geoJson.properties.deviceId
        this.cesiumViewer.onClickSppucDevice({
          layer,
          sppucMarkerId,
          deviceId: deviceId,
          name: item.name
        })
      } else {
        const marker = this.$cesiumPlus.markerManager.getMarkerById(item.id)
        if (marker && marker.isVisibleInScene()) {
          this.$store.dispatch('selectMarker', item.id)
        } else {
          const selectedId = item.id
          this.$store.dispatch('selectMarker', selectedId)
        }
      }
    },
    async requestPoiCount (data) {
      if (data.curPage === 1) {
        const res = await this.poiSearch({
          keywords: data.searchInputText,
          page_size: 25,
          page_num: 1,
          region: this.clientCityId,
          city_limit: true,
          show_fields: 'business,photos'
        })
        if (res.code !== 200) {
          return
        }
        this.totalCount = res.data.pois.length
        if (this.totalCount >= 25) {
          const res1 = await this.poiSearch({
            keywords: data.searchInputText,
            page_size: 25,
            page_num: 2,
            region: this.clientCityId,
            city_limit: true,
            show_fields: 'business,photos'
          })
          if (res1.code !== 200) {
            return
          }
          this.totalCount += res1.data.pois.length
        }
        this.requestSearchPoi(data)
      } else {
        this.requestSearchPoi(data)
      }
    },
    // 请求搜索poi
    requestSearchPoi (data) {
      this.poiSearch({
        keywords: data.searchInputText,
        page_size: 10,
        page_num: data.curPage,
        region: this.clientCityId,
        city_limit: true,
        show_fields: 'business,photos'
      }).then(res => {
        if (res.code === 200) {
          if (!this.isVisible) {
            return
          }
          this.searchList = []
          let curCount = 0
          if (res.data.pois.length >= 10) {
            curCount = (data.curPage + 1) * 10
          } else {
            curCount = (data.curPage - 1) * 10 + res.data.pois.length
          }
          if (curCount > this.totalCount) {
            this.totalCount = curCount
          }
          for (let i = 0; i < res.data.pois.length; i++) {
            const item = res.data.pois[i]
            let location = item.location.split(',')
            location = coordtransform.gcj02towgs84(location[0], location[1]) // gcj坐标转换
            const address = item.pname + item.cityname + item.adname + item.address
            let tel = ''
            if (item.business && item.business.tel) {
              tel = item.business.tel.split(';')[0]
            }
            this.searchList.push({
              index: i,
              name: item.name,
              id: item.id,
              type: this.searchParams.searchType,
              address: address,
              tel: tel,
              poistion: [parseFloat(location[0]), parseFloat(location[1])],
              icon: require(`@/assets/images/red${i + 1}.png`)
            })
          }
          this.loadPoiMarkers(this.searchList)
          this.$emit('selectedPoi', undefined)
        }
      })
    },
    // 获取图层样式
    getLayerStyle (layerId) {
      for (let i = 0; i < this.layerList.length; i++) {
        if (this.layerList[i].id === layerId) {
          let style
          if (this.layerList[i].type === 'POINT') {
            style = markerStyles.adapterPointStyle(this.layerList[i].pointStyle)
          } else if (this.layerList[i].type === 'LINE') {
            style = markerStyles.adapterLineStyle(this.layerList[i].lineStyle)
          } else if (this.layerList[i].type === 'PLANE') {
            style = markerStyles.adapterPolygonStyle(this.layerList[i].planeStyle)
          }
          style.orginType = this.layerList[i].type
          return style
        }
      }
    },
    // 请求搜索标注
    requestSearchMarker (data) {
      this.markerSearch({
        keyword: data.searchInputText,
        mapId: this.$route.query.mapId,
        pageNumber: data.curPage,
        pageSize: 10
      }).then(res => {
        if (res.code === 200) {
          if (!this.isVisible) {
            return
          }
          this.searchList = []
          this.totalCount = res.data.total
          for (let i = 0; i < res.data.records.length; i++) {
            const item = res.data.records[i]

            const style = this.getLayerStyle(item.layerId)
            let icon = 'noodles-a.png'
            if (style.orginType === 'POINT') {
              icon = 'spot-a.png'
            } else if (style.orginType === 'LINE') {
              icon = 'line-a.png'
            } else if (style.orginType === 'PLANE') {
              icon = 'noodles-a.png'
            }
            this.searchList.push({
              index: i,
              name: item.name,
              id: item.id,
              layerId: item.layerId,
              type: this.searchParams.searchType,
              geoJson: item.geoJson,
              markerType: style.orginType,
              icon: require(`@/assets/images/${icon}`)
            })
          }
          this.loadMarkerList(this.searchList)
        }
      })
    },
    // 本地标注搜索
    async searchLocalMarker (data) {
      let { records } = await this.searchMarker({
        keyword: data.searchInputText
      })
      const sppucRecords = await this.searchSppucMarker({
        keyword: data.searchInputText
      })
      records = records.concat(sppucRecords.records)
      this.totalCount = records.length
      const pageNumber = data.curPage
      const pageSize = 10
      const startIndex = (pageNumber - 1) * pageSize
      const endIndex = pageNumber * pageSize
      const loadDatas = records.slice(startIndex, endIndex)
      this.searchList = []
      for (let i = 0; i < loadDatas.length; i++) {
        const item = loadDatas[i]
        const style = this.getLayerStyle(item.layerId)
        this.searchList.push({
          index: i,
          name: item.name,
          id: item.id,
          layerId: item.layerId,
          type: this.searchParams.searchType,
          geoJson: item.geoJson,
          markerType: style.orginType
        })
      }
      this.loadMarkerList(this.searchList)
    },
    onPageChanged (page) {
      this.curPage = page
      const params = JSON.parse(JSON.stringify(this.searchParams))
      params.curPage = this.curPage
      this.$store.commit('SET_SEARCH_PARAMS', params)
    },
    // 加载poi搜索标注
    async loadPoiMarkers (datas) {
      this.$cesiumPlus.markerManager.removeMarkerByLayer('poisearch')
      for (let i = 0; i < datas.length; i++) {
        const item = datas[i]
        await this.$cesiumPlus.markerManager.createMarker({
          layerId: 'poisearch',
          name: item.name,
          position: item.poistion,
          id: 'poisearch-' + item.id,
          // allowPick: false,
          properties: {
            index: i
          },
          billboard: {
            show: true
          },
          drawMode: CesiumPlus.DrawMode.Marker,
          style: [
            new CesiumPlus.BillboardStyle({
              image: require(`@/assets/images/red${i + 1}.png`),
              color: Cesium.Color.fromCssColorString('#FFFFFF'),
              show: true
            })
          ]
        })
      }
    },
    // 更新标注样式
    updateMarkerStyle (marker, style) {
      if (!marker.show && style.type === 'heatMap') {
        return
      }
      if (style.type === 'wall') {
        if (!marker.entity.wall) {
          const _positions = marker.entity.polyline.positions
          marker.entity.wall = new Cesium.WallGraphics({
            show: true,
            positions: _positions
          })
          marker.entity.polyline = undefined
        }
      } else if (style.type === 'polyline') {
        if (!marker.entity.polyline) {
          const _positions = marker.entity.wall.positions
          marker.entity.polyline = new Cesium.PolylineGraphics({
            show: true,
            positions: _positions
          })
          marker.entity.wall = undefined
        }
      }
      marker.setStyle([style])
    },
    // 加载地图上未显示的搜索标注
    loadMarkerList (datas) {
      this.$cesiumPlus.markerManager.removeMarkerByLayer('markerSearch')
      for (let i = 0; i < datas.length; i++) {
        const item = datas[i]
        const marker = this.$cesiumPlus.markerManager.getMarkerById(item.id)
        if (marker && marker.isVisibleInScene()) {
          continue
        }
        const geoJsonData = JSON.parse(JSON.stringify(item.geoJson))
        geoJsonData.id = `markerSearch-${item.id}`
        geoJsonData.layerId = 'markerSearch'
        geoJsonData.markerName = item.name
        geoJsonData.index = item.index.toString()
        let style = this.getLayerStyle(item.layerId)
        if (!style || style.type === 'heatMap') {
          style = markerStyles.getDefaultStyle(item.markerType)
        }
        this.$cesiumPlus.markerManager.addMarkerFromGeoJson(geoJsonData, [style]).then((marker) => {
          this.updateMarkerStyle(marker[0], style)
        })
      }
    },
    close () {
      this.isVisible = false
      this.curPage = 1
      this.totalCount = 50
      this.searchList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.searchList{
  position: absolute;
  top: 45px;
  left: 270px;
  z-index: 1001;
  width: 260px;
  height: 447px;
  background: rgba(61, 62, 64, 0.95);
  border: 1px solid #565759;
  border-radius: 12px;
  &.fade-left-visible{
    left: 270px;
    transition:all 0.3s;
  }
  &.fade-left-invisible{
    left: 10px;
    transition:all 0.3s;
  }
  ul{
    padding: 0;
    margin: 0;
  }
  li{
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .search-result{
    width: 100%;
    height: 400px;
    margin-top: 4px;
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #FFFFFF;
    overflow-y: overlay;
    li {
      padding: 0 10px;
      text-align: left;
      .poi-image{
        margin: 0 6px;
        vertical-align: baseline;
        // width: 20px;
        transform: scale(0.8);
      }
      img{
        margin: 0 6px;
        vertical-align: baseline;
        // width: 20px;
        transform: scale(0.8);
      }
      .markerImg{
        transform: scale(0.6);
      }
      .line{
        width: 236px;
        height: 1px;
        background: #F0F0F0;
        opacity: 0.1;
        border-radius: 0px;
        margin-top: -1px;
      }
      &:hover,
      .active {
        background: rgba(#0076F6, 0.1);
      }
    }
    span {
      display: inline-block;
      width: 200px;
      height: 34px;
      line-height: 34px;
      @include show_ellipsis(1)
    }
    .point-icon{
      display: inline-block;
      align-items: center;
      margin-left: -6px;
      margin-right: 4px;
      vertical-align: bottom;
      height: 34px;
      svg,
      img{
        width: 24px;
        height: 24px;
      }
    }
  }
  .search-page{
    &.el-pagination{
      margin-top: 5px;
      text-align: left;
      .btn-prev,
      .btn-next{
        padding-left: 0px;
        padding-right: 0px;
        min-width: 25px;
      }
      &.disable-last {
        .el-pager{
          li:last-child {
            display: none !important;
          }
        }
      }
    }
    .page-slot{
      background: $primary-color;
      color: #fff;
      display: inline-block;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-radius: 6px;
    }
  }
}
</style>
